import { InjectionToken } from 'tsyringe';

export interface IStorageService {
  uploadFileToUrl(url: string, file: File): Promise<string | null>;
}

export const STORAGE_SERVICE: InjectionToken<IStorageService> = 'StorageService';
